import React, { useEffect, useState } from 'react'
import { Button, Col, FormGroup, InputGroup, InputGroupText, Label, Row } from 'reactstrap';
import ReactSelect from 'react-select';
import Calendar from 'assets/icon/calendar-icon.svg';
import ReactInputMask from 'react-input-mask';
import { Formik } from 'formik';
import DatePicker from 'react-datepicker';
import searchiocn from "assets/icon/search.svg";
import reseticon from "assets/icon/reset.svg";
import useAxios from 'hooks/useAxios';
import { Option, LimitedChipsContainer } from 'components/Options';
import moment from 'moment';

let hasDatePopupOpen = false;
let coveredEntitiesData = [];
let accumulationData = [];

const SearchDashboard = (props) => {
    const {
        orgId,
       onsearch,
       search,
       searchTerms,
        addCrosswalk,
        startDateValue,
        endDateValue,
        setEndDate,
        setStartdate,
        onreset,
        auditCreated,
        tableData,
        totalrecords,
        selectedviewAudit,
        setSelectedViewAudit,
        setLoading,
        loading,
        selectsearch,  setSelectSearch,
    } = props;
     const [hasACCSelected, setACCSelected] = useState(true);
        const [selectedAccountType, setAccountTypeSelected] = useState(0);
        const [isAuidt,setIsAudit]= useState(false);
        const [selectedCEOption, setCEOptionSelected] = useState({
            optionCESelected: "-1",
          });
          const [selectedACCOption, setOptionACCSelected] = useState({
            optionACCSelected: "-1",
          });
          const [accountType, setAccountType] = useState([]);
          const [hasCESelected, setCESelected] = useState(true);
          const API = useAxios();
          const coveredEntities=[{label:"PharmaForce DSH 1 ",value:51}]
          const accumulators = [{ label: "PharmaForce DSH 1", value: 1 }]; 
        //    useEffect(() => {
        //           setCESelected(true);
        //           setACCSelected(true);   
        //           coveredEntitiesData = [];
        //           accumulationData = [];
        //           dashboard.searchTerms.coveredEntityIDs = {};
        //           dashboard.searchTerms.accumulationIDs = {}
        //           dashboard.accumulations = [];
        //           updateStates(dashboard);
        //           setCEOptionSelected({ optionCESelected: '-1' });
        //           setOptionACCSelected({ optionACCSelected: '-1' });
        //           setAccountTypeSelected('');
                 
                 
        //           fetchCoveredEntities();
        //           serIsSubmitted(false);
        //         },[orgId]);
                const handlereset =()=>{
                  setSelectedCoveredEntity(null)
                  setSelectedAccumulator(null)
                  setSelectSearch(false)
                  setEndDate(null)
                  setStartdate(null)
                }
        //         const fetchCoveredEntities = async () => {
        //           let { organizationID } = orgId;
        //           if (organizationID !== -1) {
        //               coveredEntitiesData = [];
        //               dashboard.searchTerms.coveredEntityIDs = {};
        //               updateStates(dashboard);
          
        //               let selectedOrgId = orgId.organizationID;
          
        //               setLoading(false);
        //               try {
        //                   const { data } = await API.get(`SBConfig/coveredentity/list/${selectedOrgId}`, {
        //                       hasDefaultURL: true,
        //                   });
        //                   setLoading(false);
        //                   if (data) {
        //                       for (var x in data) {
        //                           coveredEntitiesData.push({ "value": data[x].coveredEntityID, "label": data[x].coveredEntityName });
        //                       }
        //                       console.log(data,"Data");
        //                       dashboard.coveredEntities = data;
                              
        //                       if (coveredEntitiesData.length == 1) {
        //                             var ceData = [];
        //                             ceData.push(coveredEntitiesData[0])
        //                             dashboard.searchTerms.coveredEntityIDs = ceData;
        //                             window.selectedCoveredEntittyId = ceData;
        //                         }
        //                         if(window.selectedCoveredEntittyId.length > 0){
        //                           dashboard.searchTerms.coveredEntityIDs = window.selectedCoveredEntittyId;
        //                         }
          
        //                       updateStates(dashboard);
        //                       if (dashboard.searchTerms.coveredEntityIDs) {
          
        //                           var ceSelected = [];
        //                           ceSelected.optionCESelected = [];
        //                           for (var x in dashboard.searchTerms
        //                             .coveredEntityIDs) {
        //                             ceSelected.optionCESelected.push(
        //                               dashboard.searchTerms.coveredEntityIDs[x]
        //                             );
        //                           }
        //                           setCEOptionSelected(ceSelected);
        //                           let ceIds = dashboard.searchTerms.coveredEntityIDs.map(item => item["value"]);
        //                           fetchAccumulatorName(ceIds);
        //                       }
          
        //                   }
        //               }
        //               catch (err) {
        //                   setLoading(false);
        //               }
        //           }
          
        //       };
          
    const handleMouseLeave = () => {
        hasDatePopupOpen = false;
    };
    const handleDateClick = (id) => {

        if (hasDatePopupOpen) {
            hasDatePopupOpen = false;
            return;
        }
        const calendarButton = document.getElementById(id);
        if (calendarButton) {
            calendarButton.click();
            hasDatePopupOpen = true;
        }
    };
    const handlesearch = async ()=>{
      if(selectedCoveredEntity && selectedCoveredEntity){
      await onsearch()
      }
    }
   
  //   const [selectedCoveredEntity, setSelectedCoveredEntity] = useState(null);
  // const [selectedAccumulator, setSelectedAccumulator] = useState(null);

  // const handleCoverdEntityChange = (selectedOption) => {
  //   setSelectedCoveredEntity(selectedOption);
  //   // Automatically select the corresponding accumulator
  //   const correspondingAccumulator = accumulators.find(acc => acc.value === selectedOption.value);
  //   setSelectedAccumulator(correspondingAccumulator);
  // };
  const [selectedCoveredEntity, setSelectedCoveredEntity] = useState(null);
  const [selectedAccumulator, setSelectedAccumulator] = useState(null);
  const [isAccumulatorDisabled, setIsAccumulatorDisabled] = useState(false);

  const handleCoverdEntityChange = (selectedOption) => {
    setSelectedCoveredEntity(selectedOption);
     console.log(selectedOption,"option")

    if (accumulators.length === 1) {
      setSelectedAccumulator(accumulators[0]);
      setIsAccumulatorDisabled(true);
    } else {
      setSelectedAccumulator(null);
      setIsAccumulatorDisabled(false);
    }
  };
   const handleStartDateRaw = (e) => {
      
      var val = e.target.value;
      if (val == '__/__/____' && startDateValue !== null) {
         setStartdate(null);
        //  setError(false)
      }
      if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
          handleStartDate(e.target.value);
      }
  }
   
  const handleStartDate = (startDate) => {
    
      if (startDate !== null) {
          const date = moment(startDate, 'MM/DD/YYYY', true);
          if (date.isValid()) {
              setStartdate(date.toDate());
          }
          // handlecount()
  
      }
      else {
          setStartdate(null);
      }
  };
   const handleEndDate = (endDate) => {
      if (endDate !== null) {
          const date = moment(endDate, 'MM/DD/YYYY', true);
          if (date.isValid()) {
              setEndDate(date.toDate());
          }
          // handlecount()

      } else {
          setEndDate(null);
      }
  };
   
  const handleEndDateRaw = (e) => {
      var val = e.target.value;
      if (val == '__/__/____' && endDateValue !== null) {
        setEndDate(null);
        // setError(false)
      }
   
      if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
          handleEndDate(e.target.value);
      }
  }
    
  return (
    <div>

<div>
        <h5 className="f-16 text-primary font-weight-700">
              Search Dashboard
            </h5>

        <Formik
                             initialValues={''}
                            onSubmit={""}
                            // validationSchema={validationSchema}
                            // enableReinitialize={true}
                            children={(props) => {
                             const { isSubmitting, handleSubmit, resetForm, setFieldValue, errors, touched } = props;
                                return (
                                    <div hidden={""}>
                               
                                        <div >
                                        <Row sm={5} className='d-flex'style={{}}>
                                        <Col md={3} lg={3} sm={6} xs={6}>
        <FormGroup>
          <Label for="coveredentity">Covered Entity</Label>
          <ReactSelect
            name="coveredentity"
            id="coveredentity"
            options={coveredEntities}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
               components={{
                                      Option,
                                    }}
            isClearable={false}
            isSearchable={true}
            onChange={handleCoverdEntityChange}
            value={selectedCoveredEntity}
            className="claim_info required"
            maxMenuHeight={220}
            styles={{ menu: (provided) => ({ ...provided, zIndex: 99 }) }}
          />
        </FormGroup>
      </Col>

      <Col md={3} lg={3} sm={6} xs={6}>
        <FormGroup>
          <Label for="accumulator">Accumulator</Label>
          <ReactSelect
            name="accumulator"
            id="accumulator"
            options={selectedCoveredEntity ? accumulators : []}
            closeMenuOnSelect={false}
            isClearable={true}
            hideSelectedOptions={false}
            isSearchable={true}
            value={selectedAccumulator}
            isDisabled={isAccumulatorDisabled}
            className="claim_info required"
            maxMenuHeight={220}
            styles={{ menu: (provided) => ({ ...provided, zIndex: 99 }) }}
          />
        </FormGroup>
      </Col>
    

                            <Col md={3} className='purchase-date'>
                                            
                                                <FormGroup>
                                                    <Label></Label>
                                                    <Label
                                                        // htmlFor="StartDate" for='reportname'
                                                        // className={focusedInput === 'StartDate' ? 'label-focus' : ''}
                                                    >Start Date</Label>
                                                    <InputGroup onMouseLeave={handleMouseLeave}>
                                                        {/* <Field
                                                            setcss="required"
                                                            type='text'
                                                            id='StartDate'
                                                            name='StartDate'
                                                            autoComplete='off'
                                                            placeholder='Select a date'
                                                            value={startDateValue}
                                                            component={FormikDatePicker}
                                                            onChange={handleStartDate}
                                                            onFocus={() => handleFocus('StartDate')}
                                                            onBlur={handleBlur}
                                                        /> */}
                                                                 <DatePicker
                                                         
                                                         id='startDate'
                                                         name='startDate'
                                                         selected={startDateValue}
                                                       
                                                         onChange={(startDate)=>handleStartDate(startDate)}
                                                        //  onFocus={() => handleFocus('StartDate')}
                                                        //  onBlur={handleBlur}
                                                         isClearable
                                                         onChangeRaw={handleStartDateRaw}
                                                         dateFormat="MM/dd/yyyy"
                                                         placeholderText='Select a date'
                                                         autoComplete='off'
                                                         customInput={
                                                             <ReactInputMask mask="99/99/9999"
                                                                 value={startDateValue}
                                                             // maskChar=''
                                                             />
     
                                                         }
                                                     />
                                                        <InputGroupText
                                                            onClick={() => handleDateClick('startDate')}
                                                        >
                                                            <img src={Calendar} alt=''/>
                                                        </InputGroupText>
                                                    </InputGroup>
                                                    {/* {
                                            error && startDateValue == null ? (
                                              <div className="text-danger f-12 position-absolute">
                                                {startDateError}
                                              </div>
                                            ) : null} */}
                                                </FormGroup>
                                                </Col>
                                                <Col md={3} className ='purchase-date'>
                                                <FormGroup>
                                                <Label></Label>
                                                    <Label
                                                       
                                                        // className={focusedInput === 'EndDate' ? 'label-focus' : ''}
                                                    >End Date</Label>
                                                    <InputGroup onMouseLeave={handleMouseLeave}   >
                                                 
                                                        {/* <Field
                                                            setcss="required"
                                                            type='text'
                                                            id='EndDate'
                                                            name='EndDate'
                                                            autoComplete='off'
                                                            placeholder='Select a date'
                                                            value={endDateValue}
                                                            component={FormikDatePicker}
                                                            onChange={handleEndDate}
                                                            onFocus={() => handleFocus('EndDate')}
                                                            onBlur={handleBlur}
                                                        /> */}
                                                        <DatePicker
                                                         
                                                         id='endDate'
                                                         name='endDate'
                                                        //  onFocus={() => handleFocus('EndDate')}
                                                        //  onBlur={handleBlur}
                                                         selected={endDateValue}
                                                         minDate={startDateValue}
                                                         onChange={handleEndDate}
                                                         onChangeRaw={handleEndDateRaw}
                                                         dateFormat="MM/dd/yyyy"
                                                        // dateFormat="yyyy/mm/dd"
 
                                                         placeholderText='Select a date'
                                                         autoComplete='off'
                                                         customInput={
                                                             <ReactInputMask mask="99/99/9999"
                                                                 value={endDateValue}
                                                             // maskChar=''
                                                             />
     
                                                         }
                                                     />
                                                        <InputGroupText
                                                            onClick={() => handleDateClick('endDate')}
                                                        >
                                                            <img src={Calendar} alt='' />
                                                        </InputGroupText>
                                                    </InputGroup>
                                                    {/* { error && endDateValue == null ?<div className="text-danger f-12">
                                                      {endDateError}</div>:''} */}
                                                    {/* {(error) && startDateValue > endDateValue?<div className="text-danger f-12">
                                                        StartDate should be greater than EndDate or Null</div>:''} */}
                                                </FormGroup>
                                            </Col>
                          
                           
                            </Row>
                            </div>
                            <div hidden={""}>
                            <Row md="auto" style={{justifyContent:"flex-end",}}>
                            <Col sm={2} className="d-flex justify-content-end">
                             <Button
                                                              
                                                               color="primary"
                                                               className="search"
                                                               onClick={handlesearch}
                                                            //    hidden={!(hasPermission('AD'))}
                                                               // hidden={!isAuidt}
                                                           >
                                                             <span className="right_5">
                                                                                 <img src={searchiocn} alt="" />
                                                                               </span>{" "}
                                                               Search
                                                           </Button>
                                                           <Button
                                                              
                                                              color="primary"
                                                              className="reset"
                                                            onClick={handlereset}
                                                            //   hidden={!(hasPermission('AD'))}
                                                              // hidden={!isAuidt}
                                                          >
                                                            <span className="right_5">
                                                                                <img src={reseticon} alt="" />
                                                                              </span>{" "}
                                                              Reset
                                                          </Button>
                              
                               
                             
                            </Col>
                            </Row>
                            </div>
                                    </div>);
                            }}></Formik>
                  
                       


    </div>
    </div>
  )
}

export default SearchDashboard